import { render } from "./moduleShopDetail.vue?vue&type=template&id=aa1b626e&scoped=true"
import script from "./moduleShopDetail.vue?vue&type=script&lang=js"
export * from "./moduleShopDetail.vue?vue&type=script&lang=js"

import "./moduleShopDetail.vue?vue&type=style&index=0&id=aa1b626e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1b626e"]])

export default __exports__